import React, {Component} from 'react';
import vehicleMarker from '../assets/vehicle-marker.svg';
import destinationMarker from '../assets/destination-marker.svg';

class Map extends Component {

    componentDidMount() {
        this.geocoder = new window.google.maps.Geocoder();
        this.trafficLayer = new window.google.maps.TrafficLayer();
        this.bounds = new window.google.maps.LatLngBounds();
        this.markers = [];

        this.setupMap();
        this.addTraffic();
        this.addDeliveryAddress(this.props.address);
        this.addVehicleMarker();
    }

    setupMap() {
        this.map = new window.google.maps.Map(this.refs.map, {
            zoom: 16,
            disableDefaultUI: true,
            clickableIcons: false,
        });
    }
    addTraffic() {
        this.trafficLayer.setMap(this.map);
    }
    addDeliveryAddress(geocode_address) {
        this.geocoder.geocode({address: geocode_address}, (results, status) => {
            if (status === 'OK') {
                this.map.setCenter(results[0].geometry.location);
                let delivery_marker = new window.google.maps.Marker({
                    map: this.map,
                    icon: destinationMarker,
                    title: "Delivery Address",
                    position: results[0].geometry.location
                });

                const infoWindow = new window.google.maps.InfoWindow({
                    content: `<div class="info-window"><p>Delivery Address:</p><h4>${this.props.address}</h4></div>`,
                    maxWidth: 180,
                });

                delivery_marker.addListener('click', function() {
                    infoWindow.open(this.map, delivery_marker);
                });

                this.markers.push(delivery_marker);
                this.setCenter();
            } else {
                var str = geocode_address;
                str = str.substring(str.indexOf(", ") + 1);
                this.addDeliveryAddress(str.trim());
            }
        });
    }
    addVehicleMarker() {
        fetch(`${process.env.REACT_APP_API_URL}vehicle/location/${this.props.driver_name}`).then((response) => {
            if(response.status === 404) {
                console.error('User not found.', this.props.driver_name);
            } else if(response.status !== 200) {
                console.warn('An error occured.', this.props.driver_name);
            }
            return response.json();
        }, (error) => {
            console.error(`API Error: ${error}`);
        }).then((json) => {
            let vehicle_marker = new window.google.maps.Marker({
                map: this.map,
                title: json.name,
                icon: vehicleMarker,
                position: {
                    lat: json.lat,
                    lng: json.lng,
                }
            });

            const infoWindow = new window.google.maps.InfoWindow({
                content: `<div class="info-window"><p>Your driver for this order is <strong>${this.props.driver_name}</strong></p></div>`,
                maxWidth: 180,
            });

            vehicle_marker.addListener('click', function() {
                infoWindow.open(this.map, vehicle_marker);
            });

            this.markers.push(vehicle_marker);
            this.setCenter();
        });
    }

    setCenter() {
        for (var marker of this.markers) {
            this.bounds.extend(marker.position);
        }
        this.map.fitBounds(this.bounds);
    }

    render() {
        return (
            <div ref="map" id="map">Visible map</div>
        );
    }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map.js